// import logo from './logo.svg';
import Weather from "./Weather";
import "./App.css";

function App() {
  //
  return (
    <div className="App">
      <div className="container">
        <h1>Weather App</h1>
        <Weather />

        <footer>
          Coded by{" "}
          <a
            href="https://www.linkedin.com/feed/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Juliana Ekemezie{" "}
          </a>
          and Open-sourced on{" "}
          <a
            href="https://github.com/JulianaEkemezie/final-react-project"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
